import { isNativePlatform } from '../runtime'

/**
 * PWA install UI (#1690, addendum §5.2 row 5): "beforeinstallprompt ורישום
 * service worker אינם מוצגים או מופעלים בתוך build נייטיבי." (spec.md §9.3:
 * "אין להציג prompt להתקנת PWA בתוך המעטפת. פריט התקנת האפליקציה מוסתר
 * ב-native runtime.")
 *
 * A native build is already installed from a store — offering to "install"
 * it again as a PWA is nonsensical and, worse, `beforeinstallprompt` firing
 * inside a Capacitor WebView (some Android WebView builds do dispatch it)
 * would show the user a broken flow. index.js and useInstallPrompt.js gate on
 * this before wiring the listener / registering the PWA service worker.
 */
export function isPwaInstallUiEnabled() {
  return !isNativePlatform()
}
